<template lang="pug">
#eTilang
    //- Header Global
    .change-on-mobile
        button.mobile-only.overlay-button(
            v-on:click="toggleSidebar()"
        )
            .btn-change-menu
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-left"><polyline points="15 18 9 12 15 6"></polyline></svg>
        HeaderGlobal(HeaderGlobalHeading="eTilang" :HeaderGlobalBreadcrumb="breadcrumb")
    .box
        .box__header.no-border
            header.flex.items-center.justify-between
                .header-meta
                    h2.subheading eTilang
                .header-cta.flex.items-center
                    //- router-link.link-text(to="#") Visit account

        .box__body.p-4
            template(v-if="load_data_status_etle.status === 'loading'")
                    Loading(show="true")
            template(v-else-if="etle && etle.length > 0")
                .flex.flex-wrap.border-b.mb-8
                    .block.px-4(class="w-full lg:w-3/12")
                        .block.mb-4
                            span.block.mb-1 No. Plate
                            p.text-light {{etle[0].plate}}
                    .block.px-4(class="w-full lg:w-3/12")
                        .block.mb-4
                            span.block.mb-1 Plate Color
                            p.text-light {{etle[0].plateColor}}
                    .block.px-4(class="w-full lg:w-3/12")
                        .block.mb-4
                            span.block.mb-1 Vehicle Color
                            p.text-light {{etle[0].vehicleColor}}

                    .block.px-4(class="w-full lg:w-3/12")
                        .block.mb-4
                            span.block.mb-1 Vehicle Type
                            p.text-light {{etle[0].vehicleType}}

                .table-static.w-full
                    table
                        thead
                            tr
                                th(v-for="(th,index) in tableThead" :key="index" :class="(th.number && th.number===true ? 'number' : '')+(th.action && th.action===true ? ' thead-action' : '')") {{ th.name }}
                        tbody
                            tr(v-if="load_data_status_etle.status === 'loading'")
                                td.text-center(:colspan="tableThead.length")
                                    .flex.flex-wrap.items-center.justify-center
                                        Spinner(show="true" size="48")
                                    
                            template(v-else-if="etle && etle.length > 0")
                                tr(v-for="(data,index) in etle" :key="data.id")
                                    td {{ data.captureDate?data.captureDate:'-' }}
                                    td {{ data.crossingName?data.crossingName:'-' }}
                                    td {{ data.directionName?data.directionName:'-' }}
                                    td {{ data.vehicleType?data.vehicleType:'-' }}
            NoDataAvailable(v-else)
    //- end

</template>

<script>
import HeaderGlobal from './../../components/HeaderGlobal.vue'
import { mapState } from 'vuex';
import Loading from '@/components/Loading.vue';
import NoDataAvailable from '@/components/NoDataAvailable.vue';

export default {
    name: 'eTilang',
    components: {
        HeaderGlobal,
        Loading,
        NoDataAvailable,
    },
    props: ['resultGlobalBreadcrumb'],
    data() {
        return {
            breadcrumb: [
                this.resultGlobalBreadcrumb,
                {
                    name: 'eTilang',
                    url: '/result/etilang',
                },
            ],
            tableThead: [
                {
                    name: 'Datetime',
                },{
                    name: 'Crossing Name',
                },{
                    name: 'Direction Name',
                },{
                    name: 'Vehicle Type as',
                }
            ],
        };
    },
    computed: {
        ...mapState([
            'load_data_status_etle',
            'etle',
        ]),
    },
    watch: {
        // 
    },
    methods: {
        toggleSidebar() {
            EventEmit.$emit('toggleSidebar')
        },
    },
    mounted() {
    },
}
</script>

<style lang="sass">
</style>
